import React, { useContext, useEffect, useState } from "react";
import MachineDetails from "../components/machineDetails/MachineDetails";
import { useParams } from "react-router-dom";
import { MachineContext } from "../context/MachineContext";
import Layout from "../components/layout/Layout";

const MachineDetailsPage = () => {
  const { getMachineById } = useContext(MachineContext);
  const { machineId } = useParams();
  const [machine, setMachine] = useState(null);
  const [loading, setLoading] = useState(true);

  const [singleDepartment, setSingleDepartment] = useState(null);
  const apiUrl = process.env.REACT_APP_MONGO_URL;
  console.log(loading);

  useEffect(() => {
    const fetchMachine = async () => {
      const data = await getMachineById(machineId);
      setMachine(data);
      setLoading(false);
    };
    fetchMachine();
  }, [machineId, getMachineById]);

  const oneDepartment = machine?.department;
  // Departman verilerini çekme
  useEffect(() => {
    if (!apiUrl || !oneDepartment) return; // oneDepartment undefined ise çalışmaz.

    const fetchDepartments = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/api/departments/${oneDepartment}`
        );
        if (response.ok) {
          const data = await response.json();
          setSingleDepartment(data);
        } else {
          console.error("Departman verileri getirilemedi.");
        }
      } catch (error) {
        console.error("Departman verisi hatası:", error);
      }
    };
    fetchDepartments();
  }, [apiUrl, oneDepartment]);
  

  return (
    <Layout>
      <div className="pt-16 ml-64">
        <MachineDetails
          machine={machine}
          department={singleDepartment?.name}
          machineId={machineId}
        />
      </div>
    </Layout>
  );
};

export default MachineDetailsPage;
